import { createClient } from "@supabase/supabase-js";

/** O Supabase aqui serve só para o login. Dado de negócio vem da API (ADR-0011); a chave pública não lê nada,
 *  porque o schema `app` não é exposto pela Data API (ADR-0012). */
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const chave = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase = createClient(url ?? "http://localhost:54321", chave ?? "sem-chave-local", {
  auth: { persistSession: true, autoRefreshToken: true },
});

export async function tokenAtual(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
